import React from 'react'

import useModal from '../../../lib/hooks/useModal'

import AcceptableUseModal from './AcceptableUseModal'

type AcceptableUseModalWrapperProps = {
  isOpen: boolean
}

const AcceptableUseModalWrapper = ({ isOpen }: AcceptableUseModalWrapperProps) => {
  const { hideModal } = useModal()
  const onCancel = () => {
    hideModal()
  }

  return <AcceptableUseModal isOpen={isOpen} onCancel={onCancel} />
}

export default AcceptableUseModalWrapper
